import React from 'react';
import PropTypes from 'prop-types';

import ConfirmModal from "../Global/Modals/ConfirmModal";
import ModalContainer from "../Global/Modals/ModalContainer";

const DeleteItemModal = ({ modalIsOpen, loading, onConfirmClick, onCloseClick, itemToDelete }) => {
  const itemType = itemToDelete.split(`-`)[0];

  let item;
  switch (itemType) {
    case `drill`:
      item = `practice`;
      break;

    case `pitchdiagram`:
      item = `diagram`;
      break;

    case `internalnews`:
      item = `news`;
      break;

    case `player`:
      item = `article`;
      break;

    case `education`:
      item = `article`;
      break;

    default:
      item = itemType;
  }

  return (
    <ModalContainer
      isOpen={modalIsOpen}
      closeModal={onCloseClick}
      label="Delete Content modal"
    >
      <ConfirmModal
        loading={loading}
        title="Are you sure?"
        confirmText={`Delete ${item}`}
        onConfirmClick={onConfirmClick}
        onCloseClick={onCloseClick}
      >
        <p>{`Are you sure you want to delete this ${item}? This cannot be undone.`}</p>
      </ConfirmModal>
    </ModalContainer>
  );
};

DeleteItemModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onConfirmClick: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  itemToDelete: PropTypes.string.isRequired,
};

export default DeleteItemModal;


// WEBPACK FOOTER //
// ./library/app/components/Folders/DeleteItemModal.js